import { render, staticRenderFns } from "./SignatureDetailDoc.vue?vue&type=template&id=bc449ec2"
import script from "./SignatureDetailDoc.vue?vue&type=script&lang=js"
export * from "./SignatureDetailDoc.vue?vue&type=script&lang=js"
import style0 from "./SignatureDetailDoc.vue?vue&type=style&index=0&id=bc449ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports